module.exports = function getResource(label, vars=[]) {
    const resources = {
        bopisTitle: `Achat en ligne et ramassage (${vars[0]})`,
        shippingTitle: `Panier d’expédition et de livraison (${vars[0]})`,
        basketSwitchBOPIS: 'View your Buy Online and Pick Up Basket',
        basketSwitchShipping: 'View your Shipping and Delivery Basket'
    };

    return resources[label];
};
